module.exports = __webpack_public_path__ + "static/media/ancestry-hero.66bc6452.png";